import React from "react";
import clsx from "clsx";

// Define prop types
interface SkeletonBlockProps {
  width?: string;
  height?: string;
  rounded?: string;
  className?: string;
}

const SkeletonBlock: React.FC<SkeletonBlockProps> = ({
  width = "w-full",
  height = "h-4",
  rounded = "rounded-md",
  className = "",
}) => {
  return (
    <div
      className={clsx(
        "animate-pulse bg-gray-300 dark:bg-gray-700",
        width,
        height,
        rounded,
        className
      )}
    ></div>
  );
};

export default SkeletonBlock;
